const destinations = {
  bot: {
    title: "۱. تنظیم ربات تلگرام",
    description: "کانال‌ها و گروه‌های مقصد از یک اعتبار خصوصی ربات تلگرام مرتبط با حساب فعلی شما استفاده می‌کنند. توکن‌های ذخیره‌شده هرگز به مرورگر بازگردانده نمی‌شوند و با کاربران دیگر به اشتراک گذاشته نمی‌شوند.",
    tokenLabel: "توکن ربات تلگرام",
    placeholderNew: "123456789:ABCdefGhIJKlmNoPQRsTUVwxyZ",
    placeholderReplace: "برای جایگزینی اعتبار ذخیره‌شده، توکن جدید را وارد کنید",
    save: "ذخیره توکن",
    saving: "در حال ذخیره",
    showToken: "نمایش توکن ربات",
    hideToken: "پنهان کردن توکن ربات",
    stored: "با امنیت ذخیره شده",
    notConfigured: "توکن تنظیم نشده است",
    acquirePrefix: "توکن را از",
    acquireSuffix: "دریافت کنید. ذخیره‌سازی فقط اعتبار حساب شما را در Supabase Vault ذخیره یا جایگزین می‌کند.",
  },
  targets: {
    title: "۲. کانال‌ها و گروه‌های مقصد",
    description: "کانال‌ها و گروه‌های عمومی یا خصوصی تلگرام خود را مدیریت کنید. فقط حساب فعلی شما می‌تواند این مقصدها را ببیند، ویرایش کند، آزمایش کند یا در آن‌ها منتشر کند.",
    friendlyName: "نام نمایشی",
    friendlyNamePlaceholder: "مثلاً Tech Announcements",
    channelId: "شناسه کانال یا نام کاربری",
    channelIdPlaceholder: "مثلاً @my_channel یا -100123456",
    add: "افزودن",
    addTarget: "افزودن مقصد",
    emptyTitle: "هنوز مقصدی تعریف نشده است",
    emptyDescription: "با فرم بالا یک کانال یا گروه مقصد با نام نمایشی اضافه کنید.",
    active: "فعال",
    muted: "غیرفعال",
    toggle: "تغییر وضعیت فعال مقصد {{name}}",
    connected: "متصل",
    failed: "ناموفق",
    test: "آزمایش اتصال",
    testing: "در حال آزمایش اتصال",
    remove: "حذف مقصد {{name}}",
  },
  feedback: {
    verificationSuccessful: "بررسی اتصال موفق بود",
    verificationFailed: "بررسی اتصال ناموفق بود",
    saveTokenFirst: "پیش از آزمایش مقصد، توکن ربات تلگرام را با امنیت ذخیره کنید.",
    verificationFallback: "بررسی اتصال ناموفق بود.",
    testPublished: "تأیید شد! پیام آزمایشی در {{channelId}} منتشر شد.",
    connectionFallback: "اتصال ناموفق بود. توکن ربات و دسترسی مدیر را بررسی کنید.",
    networkError: "یک خطای غیرمنتظره شبکه رخ داد.",
    enterToken: "پیش از ذخیره، توکن ربات تلگرام را وارد کنید.",
    tokenStored: "توکن ربات با امنیت برای حساب شما ذخیره شد.",
    tokenSaveFailed: "توکن ربات ذخیره نشد. دوباره تلاش کنید.",
    targetNameRequired: "یک نام نمایشی برای مقصد وارد کنید.",
    channelIdRequired: "شناسه کانال تلگرام یا نام کاربری را وارد کنید.",
  },
  guide: {
    title: "راهنمای چند مقصدی",
    intro: "ربات خصوصی خود را برای انتشار محتوای آماده‌شده در مقصدهای خود تنظیم کنید. سایر کاربران TGReposter اعتبار ربات و فهرست مقصد جداگانه دارند.",
    adminTitle: "اعطای دسترسی مدیر",
    adminDescription: "ربات باید در هر کانال یا گروه مقصد به‌عنوان مدیر اضافه شود و مجوز «ارسال پیام» داشته باشد.",
    privateTitle: "پشتیبانی از کانال‌های خصوصی",
    privateDescriptionPrefix: "برای کانال‌های خصوصی، شناسه عددی کانال را دریافت کنید (معمولاً با",
    privateDescriptionSuffix: ") شروع می‌شود؛ برای این کار یک پست را به ربات تشخیصی مانند",
    multiTitle: "فرایند انتشار چندمقصدی",
    multiDescription: "هنگام انتشار از صندوق محتوا، سرور پیام را به همه مقصدهای فعال و انتخاب‌شده ارسال می‌کند.",
    footer: "همه مقصدها به‌صورت هم‌زمان پردازش می‌شوند. اگر یک مقصد موقتاً در دسترس نباشد یا مجوز کافی نداشته باشد، مقصدهای فعال دیگر همچنان می‌توانند پست را دریافت کنند.",
  },
} as const;

export default destinations;
